import { useState, useEffect } from 'react';
import './PortfolioPreview.css';
import './HomePreview.css';
import { loadPortfolio } from '../data/portfolioStore';

// Fallback (shown if backend is offline / DB empty)
const fallback = [
  { src: '/posters/britishschool2.jpeg', label: 'British School',   tag: 'Branding' },
  { src: '/posters/h1.png',              label: 'Honey Cafe',       tag: 'Digital Marketing' },
  { src: '/posters/jumka1.png',          label: 'Jumka',            tag: 'Digital Marketing' },
  { src: '/posters/kullampu-1.png',      label: 'Kulambu Kitchen',  tag: 'Digital Marketing' },
  { src: '/posters/a.jpg.jpeg',          label: 'Arch Koncept',     tag: 'Social Media' },
  { src: '/posters/anuj-dm.png',         label: 'Anuj Tiles',       tag: 'Digital Marketing' },
];

// Category display order for the home grid
const TAG_ORDER = ['Website', 'Social Media', 'Logo', 'Digital Marketing', 'Branding', 'Broucher'];

export default function PortfolioPreview() {
  const [items, setItems] = useState(fallback);

  useEffect(() => {
    // Shared with the Portfolio page — one request per visit, not two.
    loadPortfolio()
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) return;

        // Home cards are small too, so use the lightweight thumbnails.
        const withSrc = data.map((p) => ({ ...p, src: p.thumb || p.src }));

        // Pick up to 6: spread across categories, one per client group first
        const picked = [];
        const usedGroups = new Set();
        for (const tag of TAG_ORDER) {
          for (const p of withSrc) {
            if (picked.length >= 6) break;
            if (p.tag === tag && !usedGroups.has(p.grp)) {
              usedGroups.add(p.grp);
              picked.push({ src: p.src, label: p.title || p.tag, tag: p.tag });
            }
          }
        }
        // Fill remaining slots with any leftover items
        for (const p of withSrc) {
          if (picked.length >= 6) break;
          if (!picked.some((x) => x.src === p.src)) {
            picked.push({ src: p.src, label: p.title || p.tag, tag: p.tag });
          }
        }
        if (picked.length) setItems(picked);
      })
      .catch(() => {}); // backend offline → keep fallback
  }, []);

  return (
    <section id="portfolio-preview" className="pfp-section">
      <div className="pfp-header reveal">
        <span className="section-label">Our Work</span>
        <h2 className="section-title">Real Campaigns, <em>Real Results</em></h2>
        <p className="section-sub">A glimpse of what we've delivered for businesses across Tamil Nadu.</p>
      </div>
      <div className="pfp-grid reveal stagger">
        {items.map((h, i) => (
          <a key={`${h.src}-${i}`} href="#/portfolio" className={`pfp-card reveal d${i + 1}`}>
            <img src={h.src} alt={h.label} loading="lazy" />
            <span className="pfp-label">{h.tag ? `${h.label} • ${h.tag}` : h.label}</span>
          </a>
        ))}
      </div>
      <div className="home-more reveal">
        <a href="#/portfolio" className="btn-ghost">View Full Portfolio →</a>
      </div>
    </section>
  );
}
